module.exports = __webpack_public_path__ + "static/media/10GalleryPuppets.c5ab3e06.jpeg";